import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { addressApi } from 'api/address';
import { IAddressResponseDetails } from 'types/address';

export const useAddressesByPostcode = (postcode: string): UseQueryResult<IAddressResponseDetails[]> =>
  useQuery(
    ['addresses-by-postcode', postcode],
    async () => {
      try {
        const response = await addressApi.getAddressesByPostcode(postcode);
        if (response.status !== 200) {
          throw new Error('Error fetching addresses by postcode');
        }
        return response.data || [];
      } catch (error) {
        throw new Error(error instanceof Error ? error.message : 'Unknown error occurred');
      }
    },
    {
      refetchOnMount: false,
      enabled: false,
      onError: error => {
        console.error('Error fetching postcode:', error);
      },
    },
  );
